// Single source of truth for how a TestExecutionStatus is badged/labelled in the UI.
// Used by both the test reports views and the test client's contract list so the two
// can never disagree on what a given status is called.
export const TEST_EXECUTION_STATUS_BADGE = {
  DRAFT:          { type: "neutral",   label: "Utkast" },
  PENDING:        { type: "info",      label: "Testning pågår" },
  PENDING_REVIEW: { type: "info",      label: "Inväntar granskning" },
  IN_REVIEW:      { type: "attention", label: "Under granskning" },
  IN_DEVIATION:   { type: "attention", label: "Avvikelser hanteras" },
  IN_CLARIFY:     { type: "error",     label: "Förtydligande begärt" },
  PUBLISHED:      { type: "success",   label: "Publicerad" },
  COMPLETED:      { type: "success",   label: "Avslutad" },
  APPROVED:       { type: "success",   label: "Godkänd" },
  REJECTED:       { type: "error",     label: "Underkänd" },
};

export function getTestExecutionStatusBadge(status) {
  return TEST_EXECUTION_STATUS_BADGE[status] || { type: "neutral", label: status };
}
